export type BooksyPayEntryTarget = 'activation' | 'onboarding' | 'opt-out-enablement' | 'opt-out-test-activation' | 'opt-out-landing-page'
export type BooksyPayDistributionModel = 'soft_opt_out_a' | 'soft_opt_out_b' | 'opt_in_test'

export const BOOKSY_PAY_ENTRY_TARGETS = {
  ACTIVATION: 'activation',
  ONBOARDING: 'onboarding',
  OPT_OUT_LANDING_PAGE: 'opt-out-landing-page',
} as const satisfies Record<string, BooksyPayEntryTarget>

export const BOOKSY_PAY_DISTRIBUTION_MODELS = {
  SOFT_OPT_OUT_A: 'soft_opt_out_a',
  SOFT_OPT_OUT_B: 'soft_opt_out_b',
  OPT_IN_TEST: 'opt_in_test',
} as const satisfies Record<string, BooksyPayDistributionModel>

export const SOFT_OPT_OUT_DISTRIBUTION_MODELS = [
  BOOKSY_PAY_DISTRIBUTION_MODELS.SOFT_OPT_OUT_A,
  BOOKSY_PAY_DISTRIBUTION_MODELS.SOFT_OPT_OUT_B,
] as const

export const FEE_MODE_TO_ANALYTICS_FEE_PLAN = Object.freeze({
  cx_full_cost: 'customer_fee',
  px_full_cost: 'business_fee',
})
